<template>
    <div class="background rounded-lg">
        <Block v-if="loading" />
        <v-row>
            <v-col cols="12">
                <v-radio-group v-model="typeData" class="ma-3">
                    <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
                    <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>

        <div>
                <div class="row">
                    <div class="col-12 p-2">
                        <VersatileFilter class="pt-3" advancedFilter :search="search" hideSearchField disableDates
                            @emptyFilter="clearFilter" :key="Reloadfilter" :enableDateStatus="true"
                            :columnfilterEndpoint="getProjections" :columnsSearch.sync="columsConfig">
                            <v-btn class="btn-save mb-sm-2 mx-4" @click="showOptions = !showOptions"><v-icon>mdi-table-edit</v-icon> Columnas</v-btn>
                            <DxDataGrid 
                                ref="gridRef"
                                :data-source="reportsData" 
                                :show-borders="true" 
                                :column-auto-width="true"
                                @exporting="onExporting" 
                                style="max-height: 600px;" 
                                :paging="{ enabled: false }"
                                :columns="columns"
                                >
                                <DxScrolling row-rendering-mode="virtual" showScrollbar="always" useNative="false" />
                                <DxExport :enabled="true" />
                                <DxColumnChooser 
                                    :enabled="true" 
                                    mode="select" 
                                    title="Columnas visibles" 
                                    :height="400"
                                    :width="400" />
                                <DxStateStoring
                                    :enabled="true"
                                    type="localStorage"
                                    storage-key="conf_proyecciones-grid"
                                />
                                <template #estadoTemplate="{ data }">
                                    <span
                                        :style="getEstadoStyle(data.value)"
                                        class="estado-badge"
                                    >
                                        {{ data.value }}
                                    </span>
                                </template>
                            </DxDataGrid>
                        </VersatileFilter>
                    </div>
                </div>
        </div>
        <v-dialog v-model="showOptions" width="60%" scrollable>
            <v-card>
                <div style="margin-top: .3rem;margin-bottom: .3rem; display: flex;justify-content: flex-end;">
                    <v-btn small class="btndelete" @click.prevent="showOptions = !showOptions">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
                <v-card-title>Configuración de columnas</v-card-title>
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" md="6" v-for="col in columns" :key="col.dataField" v-show="!col?.hide || col?.hide != 1">
                            <v-checkbox v-model="col.visible" :label="col.caption" @change="updateColumn(col)"></v-checkbox>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-col cols="12" class="text-right">
                        <v-btn @click="showOptions = !showOptions" class="btndisable">Continuar</v-btn>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Block from '@/components/Block.vue';
import VersatileFilter from '@/components/VersatileFilter';
import { 
    DxDataGrid, 
   // DxColumn, 
    DxExport, 
    DxScrolling, 
    DxColumnChooser,
    DxStateStoring, 
} from 'devextreme-vue/data-grid';
import { numberWithCommas } from '@/helpers/money';
import { printToExcel } from "@/helpers/printToexcel";

export default {
    name: "Projections",
    components: {
        VersatileFilter,
        DxDataGrid,
     //   DxColumn,
        DxExport,
        DxScrolling,
        Block,
        DxColumnChooser,
        DxStateStoring, 
    },
    props: ['win', 'datafilter'],
    data() {
        return {
            loading: false,
            typeData: '01',
            search: {},
            filterWarehouses: {},
            Reloadfilter: 0,
            reportsData: [],
            columsConfig: [
                {//0
                    name: "date",
                    title: "A la fecha de",
                    value: new Date().toLocaleDateString('es-ES', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    }),
                    type: "date"
                },
                {//1
                    name: "column_Warehouse",
                    title: 'Almacen',
                    value: '',
                    type: 'select',
                    options: []
                },
                {//2
                    name: "dias_pedir",
                    title: 'Días pedir',
                    value: '5',
                    type: 'number',
                    options: []
                },
                {//3
                    name: "ID_Item",
                    title: "ID Producto",
                    value: "",
                    type: "text",
                },
                {//4
                    name: "CodigoAlterno",
                    title: "Código Alterno",
                    value: "",
                    type: "text",
                },
                {//5
                    name: "ItemDescription",
                    title: "Descripción",
                    value: "",
                    type: "text",
                },
                {//6
                    name: "proveedor",
                    title: "Proveedor",
                    value: "",
                    type: "text",
                },
                {//7
                    name: 'familyID',
                    title: 'Familía',
                    value: '',
                    type: 'select',
                    options: []
                },
                {//8
                    name: 'categoryID',
                    title: 'Categoría',
                    parent: 'family',
                    value: '',
                    type: 'select',
                    options: []
                },
                {//9
                    name: 'subcategoryID',
                    title: 'Subcategoría',
                    parent: 'category',
                    value: '',
                    type: 'select',
                    options: []
                },
            ],
            Currency: JSON.parse(localStorage.getItem('branch')).Currency,
            keymaster: JSON.parse(localStorage.getItem('user')).keymaster,
            showOptions: false,
            columnData:[],
            columns: [
                { dataField: "ID_Item", caption: "ID producto", visible: true },
                { dataField: "CodigoAlterno", caption: "Código alterno", visible: true },
                { dataField: "ItemDescription", caption: "Descripción del producto", visible: true },
                { dataField: "familyName", caption: "Familia", visible: true },
                { dataField: "categoryName", caption: "Categoria", visible: true },
                { dataField: "subcategoryName", caption: "Sub Categoria", visible: true },
                { dataField: "proveedor", caption: "Proveedor", visible: true },

                {
                    caption: "Cantidad vendida (ultimos 3 meses)",
                    hide: 1,
                    columns: [
                    { dataField: "mes_1", caption: "Mes 1", visible: true },
                    { dataField: "mes_2", caption: "Mes 2", visible: true },
                    { dataField: "mes_3", caption: "Mes 3", visible: true },
                    ],
                },

                { dataField: "total_vendido", caption: "Total vendido", visible: true },
                { dataField: "ingresos_netos", caption: "Ingresos netos ($)", visible: true },
                { dataField: "promedio_mensual", caption: "Promedio mensual de ventas", visible: true },
                { dataField: "tendencia", caption: "Tendencia de ventas", visible: true },
                { dataField: "proyeccion_proximo_mes", caption: "Proyección próximo mes", visible: true },
                { dataField: "stock_actual", caption: "Existencia actual", visible: true },
                { dataField: "dias_pedido", caption: "Días de reposición", visible: true },
                { dataField: "venta_diaria_promedio", caption: "Venta promedio diaria", visible: true, format: {type: "fixedPoint",precision: 2} },
                { dataField: "stock_necesario", caption: "Existencias necesarias", visible: true, format: {type: "fixedPoint", precision: 0}},
                { dataField: "punto_reorden", caption: "Punto de reorden", visible: true },
                { dataField: "cantidad_sugerida_comprar", caption: "Cantidad sugerida a comprar", visible: true },

                {
                    dataField: "estado_inventario",
                    caption: "Estado del inventario",
                    cellTemplate: "estadoTemplate",
                    visible: true,
                },
            ],
        }
    },
    watch: {
    },
    computed:{
        isPoliclinica (){
            return this.keymaster == 'fa6646a6d6ef0c5f347a240270f49f38';
        }
    },
    async mounted() {
        if (this.isPoliclinica) {
            localStorage.removeItem("conf_proyecciones-grid");
            this.setColumnVisible('categoryName')
            this.setColumnVisible('subcategoryName')
            this.setColumnVisible('tendencia')
            this.setColumnVisible('ingresos_netos')
            this.setColumnVisible('proyeccion_proximo_mes')
            this.setColumnVisible('dias_pedido')
            this.updateForDataField('promedio_mensual', {format: {type: "fixedPoint", precision: 0}})
            this.updateForDataField('punto_reorden', {format: {type: "fixedPoint", precision: 0}})
            this.updateForDataField('cantidad_sugerida_comprar', {format: {type: "fixedPoint", precision: 0}})
            this.updateForDataField('venta_diaria_promedio', {format: {type: "fixedPoint", precision: 2}})
            
        }
        this.setSegmentation();
        await this.getWarehouse();
        //this.getProjections();
    },
    methods: {
        updateForDataField(dataField, changes) {
            const update = (cols) => {
            return cols.map(col => {
                if (col.dataField === dataField) {
                    return {...col, ...changes };
                }
                if (col.columns) {
                    return { ...col, columns: update(col.columns) };
                }
                return col;
            });
            };
            this.columns = update(this.columns);
        },
        setColumnVisible(dataField, visible = false) {
            const grid = this.$refs.gridRef?.instance;
            if (!grid) return;

            grid.columnOption(dataField, "visible", visible);
            this.columns = this.columns.map(col => {
                if (col.dataField === dataField) {
                    return { ...col, visible };
                }
                return col;
            });
        },
        updateColumn(col) {
            const grid = this.$refs.gridRef.instance;
            grid.columnOption(col.dataField, "visible", col.visible);
        },
        setSegmentation(){
            const sortByName = (arr) => [...arr].sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));
            this.columsConfig[7].options = sortByName(this.datafilter.Families);
            this.columsConfig[8].options = sortByName(this.datafilter.Categories);
            this.columsConfig[9].options = sortByName(this.datafilter.SubCategories);
        },
        getEstadoStyle(estado) {
            let defaultStyle = {
                padding: '4px 8px',
                borderRadius: '4px',
                fontWeight: 'bold',
                color: 'white',
            };
            if (estado === 'SIN STOCK') {
            return {
                ... defaultStyle, 
                backgroundColor: '#e53935',
            }
            }

            if (estado === 'REORDENAR') {
            return {
                ... defaultStyle, 
                backgroundColor: '#fb8c00',
            }
            }

            if (estado === 'OK') {
            return {
                ... defaultStyle,
                backgroundColor: '#43a047',
            }
            }
            return {}
        },
        getProjections(e) {
            this.loading = true;
            let params = {
                typeData: this.typeData,
                date: this.columsConfig[0].value,
                warehouse: this.columsConfig[1].value.value ?? this.columsConfig[1].value,
                dias_pedir: this.columsConfig[2].value,
            };

            if (e?.filter) {
                params.filter = e.filter;
            }

            return this.$API.inventoryReports.getProjections(params).then(response => {
                this.reportsData = response.data.map(element => {
                    element.ingresos_netos = this.formatMoneyField(element.ingresos_netos);
                    return element;
                });
            }).
                catch(error => {
                    console.log(error);
                }).finally(() => this.loading = false)
        },
        async getWarehouse() {
            let idbusiness = JSON.parse(localStorage.getItem("user")).businessid || "";
            let idbranch = JSON.parse(localStorage.getItem("user")).branch || "";
            this.filterWarehouses.branch = idbranch;
            this.filterWarehouses.business = idbusiness;
            this.filterWarehouses.notShowReserve = 1;
            return await this.$API.warehouse.getWarehouses(this.filterWarehouses)
                .then(response => {                   
                    this.columsConfig[1].options = response.map((warehouse) => ({ name: warehouse.Warehouse, value: warehouse.ID_Warehouse }));
                    if (this.columsConfig[1]?.options?.length > 0) {
                        this.columsConfig[1].value = this.columsConfig[1].options?.[0];
                    }
                });
        },
        clearFilter() {
            this.columsConfig[0].value = new Date().toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            this.columsConfig[1].value = this.columsConfig[1].options[0];
            this.columsConfig[2].value = '5';
            this.reportsData = [];
        },
        formatMoneyField(value) {
            return `${this.Currency}${numberWithCommas(value)}`;
        },
        onExporting(e) {
            const fecha = new Date().toISOString().slice(0, 10);
            printToExcel(e, `Reporte de ventas (${fecha})`)
        },
    }
}
</script>

<style scoped>
.background {
    background: white !important;
    color: white;
}

/* Mejoras de responsividad para el contenedor */
.versatile-filter-container {
    width: 100%;
    padding: 10px;
    overflow-x: hidden;
}

/* Media queries para dispositivos móviles */
@media (max-width: 600px) {
    .v-radio-group {
        margin: 8px 12px !important;
    }

    .v-radio-group .v-radio {
        margin-bottom: 4px;
    }

    .v-tabs .v-tab {
        font-size: 0.875rem;
        padding: 0 8px;
    }

    .versatile-filter-container {
        padding: 0 4px;
    }
}

@media (max-width: 960px) and (min-width: 601px) {
    .v-radio-group {
        margin: 12px 16px !important;
    }

    .v-tabs .v-tab {
        font-size: 0.9rem;
    }
}
</style>

<style>
.dx-datagrid-rowsview .dx-row.dx-group-row td {
    text-align: left !important;
}

.hidden-rows .dx-datagrid-content .dx-data-row {
    display: none;
    /* Oculta todas las filas de datos */
}

/* Posicionar el selector de sucursal en la línea del filtro */
.v-input--selection-controls {
    margin-top: 0 !important;
}
</style>